import { ApiError, UploadProfilePhotoResponse } from "@/types/types";
import { toast } from "react-toastify";
import { env } from "@/lib/env";
import { apiFetch } from "@/lib/apiFetch";

const PROFILESENDPOINTURL = env.NEXT_PROFILES_API_URL;

export const handleOccasionalEmailsClick = async (
  currentState: boolean,
  dispatch: (state: boolean) => void,
  idToken: string | null,
) => {
  dispatch(!currentState);
  try {
    const response = await apiFetch(
      "/api/profiles/updateOccasionalEmailsPreference",
      {
        method: "POST",
        body: JSON.stringify({
          occasional_emails: !currentState,
        }),
      },
    );
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

export const handleCommercialEmailsClick = async (
  currentState: boolean,
  dispatch: (state: boolean) => void,
  idToken: string | null,
) => {
  dispatch(!currentState);
  try {
    const response = await apiFetch("/api/profiles/updateCommercialEmails", {
      method: "POST",
      body: JSON.stringify({
        commercial_emails: !currentState,
      }),
    });
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

export const handleGlobalListingsClick = async (
  currentState: boolean,
  dispatch: (state: boolean) => void,
  idToken: string | null,
) => {
  dispatch(!currentState);
  try {
    const response = await apiFetch(
      "/api/profiles/updateGlobalListingsPreference",
      {
        method: "POST",
        body: JSON.stringify({
          global_listings: !currentState,
        }),
      },
    );
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

export const handleAdditionalDataClick = async (
  currentState: boolean,
  dispatch: (state: boolean) => void,
  idToken: string | null,
) => {
  dispatch(!currentState);
  try {
    const response = await apiFetch(
      "/api/profiles/updateAdditionalDataPreference",
      {
        method: "POST",
        body: JSON.stringify({
          additional_data: !currentState,
        }),
      },
    );
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

export const handlePersonalisedAdsClick = async (
  currentState: boolean,
  dispatch: (state: boolean) => void,
  idToken: string | null,
) => {
  dispatch(!currentState);
  try {
    const response = await apiFetch(
      "/api/profiles/updatePersonalisedAdsPreference",
      {
        method: "POST",
        body: JSON.stringify({
          personalised_ads: !currentState,
        }),
      },
    );
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

export const handleUpdateWhatsappPreferenceClick = async (
  currentState: boolean,
  dispatch: (state: boolean) => void,
  idToken: string | null,
) => {
  dispatch(!currentState);
  try {
    const response = await apiFetch("/api/profiles/updateWhatsappPreference", {
      method: "POST",
      body: JSON.stringify({
        has_whatsapp_active: !currentState,
      }),
    });
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

export const handleEmailNotificationsClick = async (
  currentState: boolean,
  dispatch: (state: boolean) => void,
  idToken: string | null,
) => {
  dispatch(!currentState);
  try {
    const response = await apiFetch(
      "/api/profiles/updateEmailNotificationsPreference",
      {
        method: "POST",
        body: JSON.stringify({
          email_notifications: !currentState,
        }),
      },
    );
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

interface URLS {
  urls: { [key: string]: string };
}

export const handleUploadProfilePhoto = async (
  newPhoto: File,
  currentState: string,
  newPhotoLocalString: string,
  dispatch: (state: string) => void,
  closeModal: () => void,
  idToken: string | null,
) => {
  if (idToken === null) {
    toast("Please reauthenticate before performing this action.", {
      type: "error",
    });
    return;
  }
  try {
    dispatch(newPhotoLocalString);
    closeModal();
    const response = await fetch(
      `${PROFILESENDPOINTURL}/generateS3UploadLinks`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken,
        },
        body: JSON.stringify({
          image_keys: [newPhoto.name],
          bucket_name: env.NEXT_PUBLIC_PROFILES_PHOTOS_BUCKET_NAME,
          root_folder_id: "profile-photos/",
        }),
      },
    );
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    const urls = (await response.json()) as URLS;
    const uploadResponse = await fetch(urls.urls[newPhoto.name], {
      method: "PUT",
      headers: {
        "Content-Type": newPhoto.type,
      },
      body: newPhoto,
    });
    if (!uploadResponse.ok) {
      const apiErr = (await uploadResponse.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    const s3Url = extractUrl(urls.urls[newPhoto.name]);
    if (s3Url === null) {
      throw new Error("Unable to upload photo in the database.");
    }

    const profileUpdatePhoto = await fetch(
      `${PROFILESENDPOINTURL}/updateProfilePhoto`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: idToken,
        },
        body: JSON.stringify({
          photo_url: s3Url,
        }),
      },
    );

    if (profileUpdatePhoto.ok) {
      const uploadedPhotoResponse =
        (await profileUpdatePhoto.json()) as UploadProfilePhotoResponse;
      dispatch(uploadedPhotoResponse.photo_url);
    } else {
      const apiErr = (await profileUpdatePhoto.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    dispatch(currentState);
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your profile photo."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

const extractUrl = (url: string): string | null => {
  const baseUrlRegex = /^(https:\/\/.*?\/.*?\/.*?\.jpeg)/;
  const match = url.match(baseUrlRegex);
  return match ? match[0] : null;
};

export const handleUpdateCountryClick = async (
  currentState: string,
  newState: string,
  dispatch: (state: string) => void,
  closeSelector: () => void,
  idToken: string | null,
) => {
  dispatch(newState);
  closeSelector();
  try {
    const response = await apiFetch("/api/profiles/updateUserCountry", {
      method: "POST",
      body: JSON.stringify({
        country: newState,
      }),
    });
    if (!response.ok) {
      const apiErr = (await response.json()) as ApiError;
      throw new Error(apiErr.message);
    }
    return;
  } catch (err) {
    if (err instanceof Error && err.message === "UNAUTHORIZED") {
      return; // already handled by redirect
    }
    const errorMessage =
      err instanceof Error ? err.message : "An unexpected error occurred.";
    dispatch(currentState);
    toast(
      errorMessage === "Failed to fetch"
        ? "Unable to update your data."
        : errorMessage,
      {
        type: "error",
      },
    );
    return;
  }
};

// export const handleUpdatePersonalInfoClick = async (
//   currentState: UserProfileData,
//   newState: Partial<UserProfileData>,
//   dispatch: (state: Partial<UserProfileData>) => void,
//   closeEditting: () => void,
//   idToken: string | null
// ) => {
//   if (idToken === null) {
//     toast("Please reauthenticate before performing this action.", {
//       type: "error",
//     });
//     return;
//   }
//   dispatch(newState);
//   closeEditting();
//   try {
//     const response = await fetch(
//       `${PROFILESENDPOINTURL}/updatePersonalInfo`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: idToken,
//         },
//         body: JSON.stringify({
//           ...newState,
//         }),
//       }
//     );
//     if (!response.ok) {
//       const apiErr = (await response.json()) as ApiError;
//       throw new Error(apiErr.message);
//     }
//     return;
//   } catch (err) {
//     const errorMessage =
//       err instanceof Error ? err.message : "An unexpected error occurred.";
//     dispatch(currentState);
//     toast(
//       errorMessage === "Failed to fetch"
//         ? "Unable to update your data."
//         : errorMessage,
//       {
//         type: "error",
//       }
//     );
//     return;
//   }
// };
